import api from "../Config/api"


export const createLogin = async (data) =>{
    const res = await api.post(`/admin/login/`,data);
    return res.data;
}